"use client";

import React from "react";
import { SectionHeading } from "@/components/cosmic/SectionHeading";
import { Reveal } from "@/components/cosmic/Reveal";
import { CosmicOrb } from "@/components/cosmic/CosmicOrb";
export default function DiscoveriesIntro() {
  return <section id="discoveries-intro" data-nav="dark" className="relative w-full max-w-full overflow-hidden pt-24 pb-10 sm:pt-28 sm:pb-12 md:pt-36 md:pb-16">
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Subtle decorative orb accent floating in the top corner; hidden on small screens to prevent overflow and lower render cost */}
        <div aria-hidden="true" className="pointer-events-none absolute -top-8 right-4 hidden opacity-60 sm:block md:right-12">
          <CosmicOrb size={120} hue="cyan" rings={2} />
        </div>

        <Reveal delay={60}>
          {/* Magazine Masthead Header using SectionHeading as h1 */}
          <SectionHeading as="h1" eyebrow="EDITORIAL MISSION • QUANTUM TELEMETRY" title="Cosmic Discoveries" description="The bridge between primary astrophysical literature and inquisitive minds. We translate peer-reviewed discoveries from leading observatories and research institutes into lucid, engaging science journalism." align="center" />
        </Reveal>

        {/* Secondary Supporting Copy in editorial container */}
        <Reveal delay={160}>
          <div className="mx-auto max-w-2xl text-center">
            <p className="font-sans text-sm leading-relaxed text-muted-foreground break-words sm:text-base sm:leading-relaxed md:text-lg">
              Every dispatch published here distinguishes between mathematically proven physics, experimental detections, and hypothetical models. We cite our scientific origins openly, demystifying the complex frontier of contemporary cosmology without sensationalism.
            </p>

            {/* Subtle Horizon Separator */}
            <div className="ql-divider my-6 max-w-xs mx-auto sm:my-8" aria-hidden="true" />
          </div>
        </Reveal>
      </div>
    </section>;
}